<template>
    <div class="main-center" style="margin-top: 95px;height: 100%">
        <div class="bkElement">
            <p class="bkTitle">{{$t("cargoTrack.title")}}</p>
        </div>
        <div>
            <div>
                <el-select v-model="search.selectedEntity" :placeholder="$t('common.pleaseSelect')"
                           clearable :popper-append-to-body="false" class="queryType">
                  <el-option v-for="item in queryEntityOptions" :key="item.codeValue"
                             :label="getDisplayValue(item)" :value="item.codeValue">
                  </el-option>
                </el-select>
                <el-select v-model="search.queryType" :placeholder="$t('common.pleaseSelect')"
                           clearable :popper-append-to-body="false" class="queryType">
                    <el-option v-for="item in queryTypeOptions" :key="item.codeValue"
                               :label="getDisplayValue(item)" :value="item.codeValue">
                    </el-option>
                </el-select>
                <el-input v-model="search.ydhTxt" class="ydhTxt"
                          :placeholder="$t('message.ydhTxtSearch')"
                          clearable
                @input="formatUpper('search','ydhTxt',search.ydhTxt)"/>
                <el-button class="searchButton" @click="selectAllYDH"
                           icon="el-icon-search">{{trackSearchButton}}
                </el-button>
            </div>
        </div>
        <div v-if="showNoDataView" class="noData">
            <no-data-view/>
        </div>

        <!--查询结果-->
        <div v-if="!showNoDataView" class="searchList">
            <div class="cardBody" v-for="(i,j) in cargoTrackInfos" :key="j">
                <!--<el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item>
                        <template slot="title">-->
                <div>
                    <img src="../../assets/image/icon/order2.svg" alt="">
                    <span class="bkTitle2">{{$t("cargoTrack.billInfo")}}</span>
                </div>
                <!--                        </template>-->
                <!--提单信息-->
                <div>
                    <el-row>
                        <div class="span-group">
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t("cargoTrack.blNo")}}</span>
                                <span>：{{i.blNo}}</span>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t("cargoTrack.por")}}</span>
                                <span>：{{i.porName}}</span>
                            </el-col>
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t("cargoTrack.pol")}}</span>
                                <span>：{{i.polName}}</span>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t("cargoTrack.pod")}}</span>
                                <span>：{{i.podName}}</span>
                            </el-col>
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t("cargoTrack.del")}}</span>
                                <span>：{{i.delName}}</span>
                            </el-col>
                    </div>
                    </el-row>
                </div>
                <p/>
                <!--航次信息-->
                <div>
                    <img src="../../assets/image/icon/order7.svg" alt="">
                    <span class="bkTitle2">{{$t("cargoTrack.voyageInfo")}}</span>
                </div>
                <div class="mainTable">
                    <el-table :data="i.cargoTrackVoyages" style="width:100%"
                              :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                              :row-style="{height:'40px'}"
                              :cell-style="{padding:'0px'}" max-height="600" highlight-current-row
                              class="voyageTable" :empty-text="$t('common.noData')">
                        <el-table-column prop="blNo" v-if="false">
                        </el-table-column>
                        <el-table-column min-width="220" prop="vesselName" :label="$t('cargoTrack.vesselName')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="80" prop="voyage" :label="$t('cargoTrack.voyage')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="180" prop="portFromName" :label="$t('cargoTrack.portFromName')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="190" prop="departureTime" :label="$t('cargoTrack.departureTime')"
                                         align="center">
                            <template slot-scope="scope">
                                <span>ETD:{{scope.row.etd}}<br/>ATD:{{scope.row.atd}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="180" prop="portToName" :label="$t('cargoTrack.portToName')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="200" prop="arrivalTime" :label="$t('cargoTrack.arrivalTime')"
                                         align="center">
                            <template slot-scope="scope">
                                <span>ETA:{{scope.row.eta}}<br/>ATA:{{scope.row.ata}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <p/>
                <!--集装箱信息-->
                <div>
                    <img src="../../assets/image/icon/order11.svg" alt="">
                    <span class="bkTitle2">&nbsp;{{$t("cargoTrack.containerInfo")}}</span>
                </div>
                <div class="mainTable">
                    <el-table :data="i.cargoTrackContainers" style="width:100%"
                              :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                              :row-style="{height:'40px'}"
                              :cell-style="{padding:'0px'}" max-height="600" highlight-current-row
                              class="containerTable" :empty-text="$t('common.noData')">
                        <el-table-column type="expand" min-width="60">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-timeline>
                                        <el-timeline-item
                                                v-for="(cargoTrackCtnDetail, index) in props.row.cargoTrackCtnDetails"
                                                :key="index"
                                                :color="cargoTrackCtnDetail.sortNo === '1.0' ? '#EE2C2C' : '#DCDCDC'"
                                                :size="cargoTrackCtnDetail.sortNo === '1.0' ? 'large' : 'normal'"
                                                :timestamp="cargoTrackCtnDetail.eventDate">
                                            【{{ cargoTrackCtnDetail.movementName }}】{{cargoTrackCtnDetail.facilityName}}
                                        </el-timeline-item>
                                    </el-timeline>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="containerNo" :label="$t('cargoTrack.containerNo')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="80" prop="containerType" :label="$t('cargoTrack.containerType')"
                                         align="center">
                        </el-table-column>
                        <el-table-column min-width="400" prop="latestDynamicDesc" :label="$t('cargoTrack.latestDynamicDesc')"
                                         align="center">
                            <template slot-scope="scope">
                                <span>【{{scope.row.movementName}}】
                                    【{{scope.row.eventDate}}】
                                    {{scope.row.facilityName}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <p/>
                <!--</el-collapse-item>
            </el-collapse>-->
            </div>

        </div>
        <div style="font-weight:bold;">
            <span class="el-icon-warning"></span>
            <span>{{$t("cargoTrack.note")}}</span>
        </div>
        <div class="footerSpan" style="margin-top: 200px">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import axios from "axios";

    export default {
        name: "cargoTrack",
        computed: {
            trackSearchButton() {
                return this.$t("common.trackSearchButton");
            },
        },
        components: {
            noDataView
        },
        data() {
            return {
                activeNames: ['1'],
                //控制按钮重复点击
                isSelectClick: false,
                showNoDataView: true,
                queryTypeOptions: [//查询类型
                    {codeValue: "1", displayValueCn: "提单号", displayValue: "B/L No."},
                    {codeValue: "2", displayValueCn: "箱号", displayValue: "Container No."},
                ],
                queryEntityOptions: [//查询主体
                    {codeValue: "1", displayValueCn: "股份", displayValue: "ZGL"},
                    {codeValue: "2", displayValueCn: "新加坡", displayValue: "ZSS"},
                ],
                search: {
                    ydhTxt: "",
                    queryType: "1",
                    selectedEntity:"",
                },
                cargoTrackInfos: [],
            }
        },
        mounted() {

        },
        methods: {
            selectAllYDH() {
                //校验单号是否为空
                if (this.search.ydhTxt == "") {
                    this.showMessage(false, this.$t("message.enterNo"), "warning");
                    return
                }
                if (this.search.queryType == "") {
                    this.showMessage(false, this.$t("message.selectType"), "warning");
                    return
                }
                //校验主体
                if (this.search.selectedEntity == "") {
                  this.showMessage(false, this.$t("message.selectEntity"), "warning");
                  return
                }

                //获取查询类型 1:提单号 2:箱号
                if (!this.isSelectClick && this.search.queryType) {

                    var valIn = this.search.ydhTxt.replace(/\s/g, "");
                    var arrYdh = valIn ? this.unique(valIn.split(",")) : [];
                    if (arrYdh.length > 0 && arrYdh.length <= 1) {
                        //显示进度条
                        // 声明一个loading对象
                        this.loadingtuo = this.$loading({
                            lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                            text: this.$t('message.searching'),    //加载动画的文字
                            spinner: 'el-icon-loading',             // 引入的loading图标
                            background: "rgb(0,0,0,0.1)",
                            target: document.querySelector(".searchList") // 设置加载动画区域
                        });
                        let that = this;
                        this.isSelectClick = true;
                        //查运单号 信息(运单号，箱型，暂扣信息，提箱信息)
                        // 手动决定前缀，这里拼接 /api 或 /sg-api
                        const prefix = this.search.selectedEntity === "1" ? "/api" : "/sg-api";
                        const url = `${prefix}/booking/getBookingInfo?queryType=${this.search.queryType}`;
                        console.log("prefix:", prefix);
                        console.log("selectedEntity:", this.search.selectedEntity);
                        // 创建独立实例 (关键步骤)axios.create() 创建的实例是纯净的，不会包含 main.js 中 Vue.prototype.axios 的拦截器
                        const requestInstance = axios.create();
                      requestInstance({
                            method: "post",
                            url: url,
                            data: {
                                blNo: valIn
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-type': 'application/json;charset=utf-8'
                            }
                        }).then(response => {
                            if (response.data.backCode === "200") {
                                if(response.data.object && response.data.object.length > 0){
                                    this.showNoDataView = false;
                                    this.cargoTrackInfos = response.data.object;

                                    //查询航次信息和集装箱信息
                                    this.cargoTrackInfos.forEach(cargoTrackInfo => {
                                        if (cargoTrackInfo && cargoTrackInfo.blNo) {
                                            this.selectAllVoyage(cargoTrackInfo);
                                            this.selectAllContainer(cargoTrackInfo);
                                        }
                                    });
                                }else{
                                    this.showNoDataView = true;
                                }
                            } else {
                                this.showNoDataView = true;
                                this.showMessage(false, this.responseCode, "error");
                            }
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                        that.loadingtuo.close();
                    } else if (arrYdh.length > 1) {
                        this.showMessage(false, this.$t("message.notSupportMulti"), "error");
                        this.showNoDataView = true;
                    }
                    this.isSelectClick = false;
                }
            },
            selectAllVoyage(cargoTrackInfo) {
                // 手动决定前缀，这里拼接 /api 或 /sg-api
                const prefix = this.search.selectedEntity === "1" ? "/api" : "/sg-api";
                const url = `${prefix}/booking/getVoyageInfo`;
                // 创建独立实例 (关键步骤)axios.create() 创建的实例是纯净的，不会包含 main.js 中 Vue.prototype.axios 的拦截器
                const requestInstance = axios.create();
              requestInstance({
                    method: "post",
                    url: url,
                    data: {
                        blNo: cargoTrackInfo.blNo
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale"),
                        'Content-type': 'application/json;charset=utf-8'
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        cargoTrackInfo.cargoTrackVoyages = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            selectAllContainer(cargoTrackInfo) {
                // 手动决定前缀，这里拼接 /api 或 /sg-api
                const prefix = this.search.selectedEntity === "1" ? "/api" : "/sg-api";
                const url = `${prefix}/booking/getContainerInfo`;
                // 创建独立实例 (关键步骤)axios.create() 创建的实例是纯净的，不会包含 main.js 中 Vue.prototype.axios 的拦截器
                const requestInstance = axios.create();
              requestInstance({
                    method: "post",
                    url: url,
                    data: {
                        blNo: cargoTrackInfo.blNo
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale"),
                        'Content-type': 'application/json;charset=utf-8'
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        cargoTrackInfo.cargoTrackContainers = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            unique(arr) {//数组去重
                //Set数据结构，它类似于数组，其成员的值都是唯一的
                return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
            },
            handleChange(val) {
                console.log(val);
            },
            initSelectedEntity() {
              this.search.selectedEntity = this.$apiUtils.getCurrentEntity();
            }
        }
        ,
        created() {
          this.initSelectedEntity();
        }
    }
</script>

<style lang="scss">

    .bkTitle {
        font-size: 25px;
        margin: 20px auto;
        font-weight: bold;
    }

    .bkTitle2 {
        width: 80%;
        font-size: 19px;
    }

    .queryType {
        border: 0;
        width: 150px;

        .el-input {
            input {
                color: #fff;
                background-color: #EE2C2C;
                font-size: 15px;
            }
        }
    }

    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }

    .ydhTxt {
        font-size: 15px;
        width: 400px;
    }

    .searchButton {
        font-size: 15px;
        background-color: #EE2C2C;
        color: #fff;
        border-color: transparent;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .noData2 {
        margin-left: 50px;
        height: 100%;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    .span-group {
        flex: 1;
        width: 650px;
        border: 0;
        line-height: 44px;
        height: 40px;
        margin-left: 50px;
    }

    .span-left {
        width: 150px;
    }

    .span-right {
        width: 500px;
    }

</style>